import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";

import { ChatData } from "../../../Chat/ChatData";
import { FirebaseDataUserField } from "../../DataObjectField/CustomFields/FirebaseDataUserField";
import { DataObjectField } from "../../DataObjectField/DataObjectField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";

export class ChatDataHelper extends DataObjectHelper<ChatData> {
  id = () => "chat";

  name = new FirebaseDataStringField<ChatData>("name", t("main.name"), (chat) => chat.name, "abc");
  updatedAt = new FirebaseDataDateField<ChatData>("updatedAt", t("main.updatedAt"), (chat) => chat.updatedAt, "today");
  members = new FirebaseDataUserField<ChatData>("members", t("main.members"), (chat) => chat.members, "groups", true);

  allFields(): DataObjectField<any, ChatData>[] {
    return [this.name, this.updatedAt, this.members];
  }
  displayName(): string {
    return t("main.chat");
  }

  override getAllDatas(): ChatData[] {
    return LocalData.currentUser.chats;
  }
  loadAll(): Promise<any> {
    const allPromises: Promise<any>[] = [];
    LocalData.currentUser.chats.forEach((chat) => allPromises.push(chat.load()));
    return Promise.all(allPromises);
  }
  getAllDataTableDatas(documents: ChatData[]): DataTableData[] {
    return documents.map((chat) => {
      return {
        key: chat.id,
        cells: {
          name: chat.name,
          updatedAt: chat.updatedAt,
          members: chat.members.length,
        },
      };
    });
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "name",
        title: t("main.name"),
      },
      {
        key: "updatedAt",
        title: t("main.updatedAt"),
      },
      {
        key: "members",
        title: t("main.members"),
      },
    ];
  }
}

